<pop-error-wrapper>
  <h1 title
      translate="PAGES.PAGENOTFOUND.TITLE"></h1>
  <p description
     translate="PAGES.PAGENOTFOUND.DESCRIPTION"></p>
  <button action
          class="pl-button"
          (click)="goHome()"
          translate="PAGES.PAGENOTFOUND.GOHOME"></button>
</pop-error-wrapper>
